import { PropsWithChildren } from "react";

import { Flex, FlexProps, Typography } from "@aircall/tractor";

export function EvaluationComment({
  children,
  ...props
}: PropsWithChildren<FlexProps>) {
  return (
    <Flex
      p="xxs"
      alignItems="center"
      backgroundColor="surface-background"
      borderRadius="8px"
      {...props}
    >
      <Typography variant="bodyRegularM">{children}</Typography>
    </Flex>
  );
}
